<script>
  import { format } from 'svelte-i18n';
  import { Tooltip } from '@sveltestrap/sveltestrap';

  export let row = {};
</script>

<div class="bricks-container">
  {#if row.categories}
    <div class="bricks">
      {#each row.categories.slice(0, 3) as category}
        <div class="brick" style="background: {category.backgroundColor}; border: 0; color: rgba(0,0,0,.4)">
          {category.text}
        </div>
      {/each}
      {#if row.categories.length > 3}
        <div class="brick more" id="tooltip-{row.rulename}-categories">
          +{row.categories.length - 3}&nbsp;{$format('label.MORE').toLowerCase()}
        </div>

        <Tooltip target="tooltip-{row.rulename}-categories">
          {@html row.categories
            .slice(3)
            .map(({ text }) => text)
            .join('<br />')}
        </Tooltip>
      {/if}
    </div>
  {:else}
    <div class="none">{$format('label.NO_ASSIGNED_CATEGORIES')}</div>
  {/if}
</div>

<style lang="scss">
  .bricks-container {
    .bricks {
      display: flex;
      flex-wrap: wrap;
      gap: 4px;
      position: relative;

      .brick {
        align-items: center;
        background-color: var(--color-white);
        border: 1px solid var(--border-color);
        border-radius: var(--border-radius-base);
        display: flex;
        font-size: var(--font-size-small);
        gap: 4px;
        padding: var(--padding-small) var(--padding-base);

        &.more {
          cursor: help;
        }
      }
    }

    .none {
      color: var(--color-gray-500);
      font-size: var(--font-size-medium);
    }
  }
</style>
